import Vue from 'vue'
import VueI18n from 'vue-i18n'
import appEn from '@/lang/app/en'
import appEs from '@/lang/app/es'
import validationsEn from '@/lang/validations/en'
import validationsEs from '@/lang/validations/es'
import backendEs from '@/lang/backend/es'
import backendEn from '@/lang/backend/en'
import dialogsEn from '@/lang/dialogs/en'
import dialogsEs from '@/lang/dialogs/es'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'es', // set default locale
  fallbackLocale: 'es',
  silentTranslationWarn: true,
  messages: {
    es: {
      backend: backendEs,
      validations: validationsEs,
      ...appEs,
      ...dialogsEs,
    },
    en: {
      backend: backendEn,
      validations: validationsEn,
      ...appEn,
      ...dialogsEn,
    },
  },
})
